<template>
  <div>
    <v-head></v-head>
    <div class="navigation">
      <div class="navigation-title">晶澳科技光/储测算工具</div>
      <div class="navigation-wrap">
        <div class="navigation-wrap-item">
          <div class="wrap-item-header">
            <div>分布式光伏户用</div>
          </div>
          <div class="wrap-item-content">
            <img src="../assets/img/h1.jpg" alt="img..." />
          </div>
          <div class="wrap-item-button" @click="getBeginCount('1')">
            开始计算
          </div>
        </div>
        <div class="navigation-wrap-item">
          <div class="wrap-item-header">
            <div>分布式光伏商用</div>
          </div>
          <div class="wrap-item-content">
            <img src="../assets/img/h2.jpg" alt="img..." />
          </div>
          <div class="wrap-item-button" @click="getBeginCount('2')">
            开始计算
          </div>
        </div>
        <div class="navigation-wrap-item">
          <div class="wrap-item-header">
            <div>工商业储能</div>
          </div>
          <div class="wrap-item-content">
            <img src="../assets/img/h9.png" alt="img..." />
          </div>
          <div class="wrap-item-button" @click="getBeginCount('3')">
            开始计算
          </div>
        </div>

        <div class="navigation-wrap-item">
          <div class="wrap-item-header">
            <div>集中式光伏产品对比</div>
          </div>
          <div class="wrap-item-content">
            <img src="../assets/img/home/home-product-compare.png" alt="img..." />
          </div>
          <div class="wrap-item-button" @click="getBeginCount('4')">
            开始计算
          </div>
        </div>

        <div class="navigation-wrap-item">
          <div class="wrap-item-header">
            <div>集中式光伏设备选型</div>
          </div>
          <div class="wrap-item-content">
            <img src="../assets/img/h11.png" alt="img..." />
          </div>
          <div class="wrap-item-button" @click="getBeginCount('5')">
            开始计算
          </div>
        </div>
      </div>
    </div>
    <v-foot></v-foot>
    <v-message></v-message>
    <login-dialog :visible.sync="loginDialogVisible" @success-login="handleSuccessLogin" />
  </div>
</template>

<script>
import vHead from "../components/top-header.vue";
import vFoot from "../components/home-foot.vue";
import vMessage from "../components/vMessage.vue";
import LoginDialog from "./Product/components/login-dialog";

export default {
  components: {
    vHead,
    vFoot,
    vMessage,
    LoginDialog,
  },
  data() {
    return {
      loginDialogVisible: false,
    };
  },

  methods: {
    /**
     * @description: 登录成功后可以进入产品比对页面
     * @return: 
     */
    handleSuccessLogin() {
      this.$router.push({ path: "/ProductComparison" });
    },
    getBeginCount(num) {
      switch (num) {
        case "1":
          this.$router.push({ path: "/HouseholdUse" });
          break;
        case "2":
          this.$router.push({ path: "/Commercial" });
          break;
        case "3":
          const url = new URL("/us/", window.location.origin);
          location.href = url.href;
          break;
        case "4":
          // 产品比对限制登录用户使用
          const token = localStorage.getItem("token");
          const tokenExpireTime = localStorage.getItem("tokenExpireTime");
          const currentTime = new Date().getTime();
          if (!token || currentTime > tokenExpireTime) {
            this.loginDialogVisible = true;
          }else {
            this.$router.push({ path: "/ProductComparison" });
          }
          break;
        case "5":
          this.$router.push({ path: "/EquipmentSelection" });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navigation {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 30px 0;
  cursor: default;
  .navigation-title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 34px;
    // font-weight:600;
  }
  .navigation-wrap {
    position: relative;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 80px;
    width: 90%;
    max-width: 1600px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;  
    gap: 40px;  // 设置统一的间距
    
    .navigation-wrap-item {
      width: calc((100% - 80px) / 3);  // 计算每个元素的宽度：(容器宽度 - 两个间隔) / 3
      max-width: 400px;
      min-width: 300px;
      height: auto;
      margin-bottom: 40px;
      
      &:nth-child(3n + 1) {  // 每行第一个元素
        margin-left: 0;
      }
      
      &:nth-child(3n + 2) {  // 每行第二个元素
        margin-left: 40px;
      }
      
      &:nth-child(3n) {  // 每行第三个元素
        margin-left: 40px;
      }
      
      .wrap-item-header {
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-size: 22px;
        font-weight: bold;
        border-bottom: 2px solid #000;
      }
      
      .wrap-item-content {
        width: 100%;
        padding-top: 75%; // 保持4:3的宽高比
        position: relative;
        margin-top: 20px;
        
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .wrap-item-button {
        width: 100%;
        height: 50px;
        margin-top: 20px;
        text-align: center;
        line-height: 50px;
        letter-spacing: 2px;
        font-size: 17px;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        background-color: #f8bc2b;
        
        &:hover {
          background-color: darken(#f8bc2b, 10%);
        }
      }
    }

    // 移除之前的伪元素
  }
}
</style>
